import { BaseBadge } from './BaseBadge'
import React from 'react'

import { UpdateReportAdTypes } from '../../util/contstants'

const updateReportAdType = {
    [UpdateReportAdTypes.Campaigns]: { text: 'Campaigns', intent: 'success' },
    [UpdateReportAdTypes.AdGroups]: { text: 'Ad Groups', intent: 'warning' },
    [UpdateReportAdTypes.ProductAds]: { text: 'Product Ads', intent: 'warning' },
    [UpdateReportAdTypes.Keywords]: { text: 'Keywords', intent: 'primary' },
    [UpdateReportAdTypes.Targets]: { text: 'Targets', intent: 'warning' },
    [UpdateReportAdTypes.KeywordsAndTargets]: { text: 'Keywords & Targets', intent: 'primary' },
    [UpdateReportAdTypes.SearchTerms]: { text: 'Search Terms', intent: 'warning' },
}

export const UpdateReportAdTypeBadge = ({ type }) => {
    return <BaseBadge value={type} options={updateReportAdType} />
}
